<template>
  <div class="row">
    <div class="hero-register d-flex align-items-center overflow-hidden position-relative w-100">
      <div class="hero-title-container text-white m-auto">
        <h1>{{ heroTitle }}</h1>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MainHero",
  props: ['heroTitle'],
}
</script>

<style scoped lang="scss">

</style>
